<div class="container">
  <div class="top">
    <h3>Gostaria de pagar a taxa?</h3>
  </div>
  <div class="buttons">
    <yoo-button
      neutral
      large
      regular
      iconLeft="smileFace"
      [block]="true"
      (click)="activateTax()"
    >
      <span>Pagar taxa</span>
    </yoo-button>
    <yoo-button
      neutral
      large
      plain
      iconLeft="sadFace"
      [block]="true"
      (click)="deactivateTax()"
    >
      <span>Não fui bem atendido</span>
    </yoo-button>
  </div>
</div>